import QRCode from 'qrcode';
import Clipboard from 'clipboard';
import { Toast } from 'vant';
import UBT from '@/utils/tianqi';
import { loadHbridge, loadQs } from './globalLoader';

/**
 * set document title when router change
 * @param {String} title title name
 */
export async function setTitle(title) {
  const { env } = await loadHbridge();
  if (env.isEasyBikeApp) return;
  document.title = title;
  const iframe = document.createElement('iframe');
  iframe.style.visibility = 'hidden';
  const iframeCallback = () => {
    setTimeout(() => {
      iframe.removeEventListener('load', iframeCallback);
      document.body.removeChild(iframe);
    }, 0);
  };
  iframe.addEventListener('load', iframeCallback);
  document.body.appendChild(iframe);
}

/**
 * cache return for function, ensure that the function is executed only once
 * @param {Function} func
 */

export function onceWrapper(func) {
  let isExecuted = false;
  let promiseObj = null;

  return (...arg) => {
    if (isExecuted) return promiseObj;
    isExecuted = true;
    promiseObj = func(...arg);
    return promiseObj;
  };
}


export function pxtorem(px) {
  const rem = px / 37.5;
  const fontSize = parseFloat(document.documentElement.style.fontSize);
  return rem * fontSize;
}

export async function goLinkUrl({ url, needLogin, ubt }) {
  if (!url) {
    return;
  }

  let redirectUrl = url;

  if (ubt) {
    UBT.customEventWithPointId({
      pointId: 'switch.pageview.flow',
      businessInfo: ubt,
    });
  } else if (process.env.VUE_APP_ENV !== 'pro') {
    // eslint-disable-next-line no-console
    throw new Error(`对外跳转场景，请添加链路埋点信息,\nurl: \n${url} `);
  }

  const { env, Native } = await loadHbridge();
  const qs = await loadQs();

  if (needLogin) {
    const {
      token,
      ticket,
      mobile,
      userGuid,
    } = await Native.getTokenAndKey();
    redirectUrl = `${redirectUrl}?${qs.stringify({
      token,
      mobile,
      userGuid,
      ticket,
    })}`;
  }


  if (env.isEasyBikeApp || env.isAliMPMonitor || env.isAliMP) {
    Native.callNative({
      method: 'openWebview',
      classMap: 'SwitchBridge',
      params: {
        url: redirectUrl,
      },
    });
  } else {
    window.open(redirectUrl);
  }
}

export async function makePhoneCall(telNo = 95175177) {
  const { Native } = await loadHbridge();
  Native.call(telNo);
}

export function noop() {}

export async function goBack() {
  const { env, Native } = await loadHbridge();
  if (env.isAliMP || env.isAliMPMonitor) {
    // 支付宝小程序，goBack会直接关闭整个webview
    const start = window.location.href;
    window.history.back();
    setTimeout(() => {
      const end = window.location.href;
      if (end === start) {
        Native.goBack();
      }
    }, 50);
  } else {
    Native.goBack();
  }
}

export async function closeWebView() {
  const { env, Native } = await loadHbridge();
  if (env.isAliMP || env.isAliMPMonitor) {
    Native.goBack();
  } else if (env.isEasyBikeApp) {
    Native.closeWebView();
  } else {
    throw new Error('未兼容');
  }
}

export function mapVant(...components) {
  const c = {};
  components.forEach((it) => {
    if (it.name && typeof it === 'object') {
      c[it.name] = it;
    // Dialog 之类组件局部注册，组件挂载在Component属性上
    } else if (it.Component) {
      c[it.Component.name] = it.Component;
    }
  });
  return c;
}

/**
 * 根据地址生成二维码图片
 */
export async function getQrcode(qrcodeUrl, width, height) {
  try {
    const url = await QRCode.toDataURL(qrcodeUrl, {
      width,
      height,
    });
    return url;
  } catch (e) {
    return '';
  }
}

// 复制到剪切板
export function copyToClipboard(Target) {
  const clipboard = new Clipboard(Target);
  clipboard.on('success', () => {
    Toast.success('复制成功');
  });
  clipboard.on('error', () => {
    Toast.error('复制失败');
  });
}
